module.exports = __webpack_public_path__ + "static/true-modularity-slide-7344c009c9a2631c266ddf7810a8725a.png";